import JWPlayer = jwplayer.JWPlayer;
import { Subject } from 'rxjs';
import EventParams = jwplayer.EventParams;
import {
  jwPlayerEventMap,
  PixelsVideoEvent
} from '../../../constants/Video';

export const jwPlayer$ = (player: JWPlayer, pageId: string) => {
  const sub = new Subject<[string, Record<string, any>]>();
  for (const [key, value] of jwPlayerEventMap.entries()) {
    player.on(value as keyof EventParams, (event: any) => {
      switch (value) {
        case jwPlayerEventMap.get(PixelsVideoEvent.VIDEO_BEFORE_PLAY): {
          const { playlist: [ video ]} = event;
          sub.next([key, {
            campaignId: video.campaignId || '',
            pageId,
            videoId: video.mediaid,
            videoDuration: video.duration
          }]);
        }
        break;
        case jwPlayerEventMap.get(PixelsVideoEvent.FIRST_FRAME): {
          const {
            mediaid: videoId,
            duration: videoDuration,
            campaignId
          } = jwplayer().getPlaylistItem();
          sub.next([key, {
            campaignId: campaignId || '',
            pageId,
            videoId,
            videoDuration,
            integrationType: 'hero'
          }]);
          break;
        }
        case  jwPlayerEventMap.get(PixelsVideoEvent.AD_STARTED):
          sub.next([key, {
            adPos: event.adposition
          }]);
          break;
        default:
          sub.next([key, event]);
      }
    });
  }
  return sub;
};